import { render } from "./DropdownContent.vue?vue&type=template&id=971364b0"
import script from "./DropdownContent.vue?vue&type=script&lang=js"
export * from "./DropdownContent.vue?vue&type=script&lang=js"

import "./DropdownContent.vue?vue&type=style&index=0&id=971364b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__